import React from 'react';
import { TimeEntry } from '../../types/time-entry';
import Card from '../Card';
import TimeEntryCard from './TimeEntryCard';

interface TimeEntriesListProps {
  timeEntries: TimeEntry[];
  getProjectName: (projectId: string) => string;
  getCategoryName: (categoryId: string) => string;
  getTaskTitle: (taskId: string) => string;
  onDeleteEntry: (entryId: string) => void;
}

const TimeEntriesList: React.FC<TimeEntriesListProps> = ({
  timeEntries,
  getProjectName,
  getCategoryName,
  getTaskTitle,
  onDeleteEntry,
}) => {
  return (
    <Card variant="glass" className="hover:-translate-y-1 transition-all duration-300">
      <Card.Header title="Time Entries" />
      <Card.Body className="max-h-96 overflow-y-auto">
        {timeEntries.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 'var(--spacing-lg)', color: 'var(--gray-500)' }}>
            No time entries for this week
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-sm)' }}>
            {timeEntries.map(entry => (
              <TimeEntryCard
                key={entry.id}
                entry={entry}
                projectName={entry.project_id ? getProjectName(entry.project_id) : undefined}
                categoryName={entry.category_id ? getCategoryName(entry.category_id) : undefined}
                taskTitle={entry.task_id ? getTaskTitle(entry.task_id) : undefined}
                onDelete={onDeleteEntry}
              />
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default TimeEntriesList;
